/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Cmp_4_TInputs */

const en_cp_cmp_4_t = /** @type {(inputs: Cp_Cmp_4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staged incubation, networking, follow-on funding.`)
};

const id_cp_cmp_4_t = /** @type {(inputs: Cp_Cmp_4_TInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inkubasi bertahap, networking, pendanaan lanjutan.`)
};

/**
* | output |
* | --- |
* | "Staged incubation, networking, follow-on funding." |
*
* @param {Cp_Cmp_4_TInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_cmp_4_t = /** @type {((inputs?: Cp_Cmp_4_TInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Cmp_4_TInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_cmp_4_t(inputs)
	return en_cp_cmp_4_t(inputs)
});